import { metabolicRhythmLabels } from './quizMeta';

const TITLES = {
  wellness_pattern_assessment: 'What Is Your Body Asking For? — Wellness Pattern Assessment',
  lifestyle_assessment: 'The Vitality Potential Tool',
  'lifestyle-assessment': 'The Vitality Potential Tool',
  metabolic_rhythm: 'Metabolic Rhythm Quiz',
  food_preferences: 'Food Preferences',
};

export const quizTitle = (type) => TITLES[type] || 'Assessment';

// Short, readable one-line result for lists (some quizzes store codes or JSON)
export const quizSummary = (q) => {
  const r = q.result;
  if (!r) return '';
  if (q.quiz_type === 'metabolic_rhythm') return metabolicRhythmLabels[r] || r;
  if (typeof r === 'string' && r.trim().startsWith('{')) {
    try {
      const j = JSON.parse(r);
      if (j.lifestyleLoadIndex !== undefined) {
        return `Lifestyle load ${j.lifestyleLoadIndex} (${j.loadStatus}) · Resilience ${j.resilienceCapacity} (${j.resilienceStatus})`;
      }
    } catch { /* fall through */ }
    return '';
  }
  return String(r);
};
